export const cleanerGridAssumption = 18; // percent cleaner grid by 2030 (from workbook Simple Baseline C38)

// conversion factors from workbook Scope 1 Factors tab (lbs C02/MMBTU)
export const electricConversionFactor = 157.3365234;
export const naturalGasConversionFactor = 117;
export const propaneConversionFactor = 139;
export const fuelOilConversionFactor = 166;

export const gasolineConversionFactor = 149;
export const dieselConversionFactor = 163;

export const stationaryElectrificationCOP = 2; // coefficient of performance for stationary electrification (from workbook Calcs M3)
export const mobileElectrificationCOP = 2; // coefficient of performance for mobile electrification (from workbook Calcs N3)
